import React from 'react'
import { FlexRow, Icon } from 'elements'
import { useModals } from 'hooks'
import ThresholdsModal from './ThresholdsModal'
import CheckButton from '../../ui/input/CheckButton'
import { formatSectionName } from '../utils/formatting'

export default function ReportSectionRow({
  reportSection,
  configSections,
  setConfigSections,
  handleCheck,
  ...props
}) {
  const { openModal } = useModals()

  const configSection = configSections.find(
    (configSection) => reportSection.name === configSection.name,
  )

  return (
    <FlexRow alignItems="center" {...props}>
      {reportSection.config ? (
        <Icon
          name="pencil"
          size="xsmall"
          mr="medium"
          color={configSection ? 'secondary.0' : 'neutral.0'}
          disabled={!configSection}
          onClick={() =>
            openModal(
              ThresholdsModal,
              {
                configSection,
                configSections,
                setConfigSections,
              },
              'semi',
            )
          }
        />
      ) : null}
      <CheckButton selected={configSection} onClick={() => handleCheck(reportSection)}>
        {formatSectionName(reportSection.name)}
      </CheckButton>
    </FlexRow>
  )
}
